<div class="container data">
<div class="display-flex-lg">
    
    <h2 class="margin-auto">For any queries kindly Email us on partner.support@truventor.com or Call us at +91 8793 738 826</h2>
</div>
</div>